import { CardBody } from "@dgs/core";
import { FC } from "react";
import styled from "styled-components";
import { CompanionResource, DataFieldWithOptionContingentCheckResource } from "../../../shared/types";
import { DataFieldValueRenderer } from "../../DataFieldValueRenderer";
import { DataFieldErrors, FilledSteps, useRegistrationForm } from "../../provider/registrationFormProviderContext";
import { toCompanionDataFieldValues } from "../../provider/registrationFormProviderUtils";
import { ValueLabel } from "../../ValueLabel";

const StyledCardBody = styled(CardBody)`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: ${({ theme }) => theme.spacing(2)};
`;

interface BaseProps {
	filledSteps: FilledSteps;
	companion: CompanionResource;
	dataFields: DataFieldWithOptionContingentCheckResource[];
	errors?: Record<string, string>;
	dataFieldErrors?: DataFieldErrors;
}

export const RegistrationCompanionInfo: FC<BaseProps> = ({
	filledSteps,
	companion,
	dataFields,
	errors,
	dataFieldErrors,
}) => {
	const { registrationForm, getHiddenDataFields } = useRegistrationForm();
	const stepsOfCompanionSection = registrationForm.steps.filter(({ children }) =>
		children.some((child) => child.entityType === "section" && child.section.id === companion.sectionId),
	);
	const isDataFieldHidden = (dataFieldId: number) => {
		return stepsOfCompanionSection.every((step) => {
			const companionFormValues = toCompanionDataFieldValues(companion);
			const hiddenDataFields = getHiddenDataFields({
				...filledSteps,
				[step.id]: { ...filledSteps[step.id], ...companionFormValues },
			});

			return hiddenDataFields.includes(`${companion.sectionId}-${dataFieldId}`);
		});
	};
	const visibleDataFields = dataFields.filter(({ id }) => !isDataFieldHidden(id));

	return (
		<StyledCardBody>
			{visibleDataFields.map((dataField, index) => {
				const prefix = `dataFieldValues.${index}.value`;

				return (
					<div key={dataField.id}>
						<ValueLabel>{dataField.label}:</ValueLabel>
						<DataFieldValueRenderer
							error={errors?.[prefix] ?? dataFieldErrors?.[dataField.id]}
							dataField={dataField}
							value={companion.dataFieldValues.find((value) => value.id === dataField.id)?.value}
						/>
					</div>
				);
			})}
		</StyledCardBody>
	);
};
